export class SearchTermMapDto {
    key: string;
    searchTerm: string;
  
    constructor(key: string, searchTerm: string) {
      this.key = key;
      this.searchTerm = searchTerm;
    }
  }
  